/**
 * DLP 보고서 PDF 모드 전용 데이터 필터링 유틸.
 *
 * 일반 UI는 admin/editor가 표시·숨김 토글 버튼을 다뤄야 하므로 모든 행을 노출하지만,
 * PDF 출력물에는 숨김 처리한 항목이 노출되면 안 된다.
 *
 * 새 배열을 반환하여 호출 측에서 자유롭게 sort 등 in-place 연산을 할 수 있게 한다.
 */
export const filterUnusedUsbForPdf = <T extends { displayYn?: string | null }>(
  items: T[],
  isPdfMode: boolean,
): T[] => (isPdfMode ? items.filter((it) => it.displayYn !== 'N') : items.slice());
